module.exports = __webpack_public_path__ + "media/images/emoticons/heart01-73fa3b40b0830700a2be2e555f658dff.gif";